import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      ...theme.typography.body1,
      color: theme.palette.greyBlue[700],
      display: 'flex',
      paddingTop: theme.spacing(1),
    },
  };
});

const HeaderSectionSubTitle = ({ children, className, ...props }) => {
  const classes = useStyles();

  return (
    <span className={clsx(classes.root, className)} {...props}>
      {children}
    </span>
  );
};

HeaderSectionSubTitle.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
};

HeaderSectionSubTitle.defaultProps = {};

export default HeaderSectionSubTitle;
